import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DesktopProjectModule } from '../project/desktop-project.module';
import { MiscModule } from 'projects/core/src/public-api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProjectMiscModule } from 'projects/app-misc/src/app/modules/project-misc/project-misc.module';
import { VendorsPageComponent } from './view/vendors-page/vendors-page.component';
import { VendorModalComponent } from './view/vendor-modal/vendor-modal.component';
import { MaterialsPageComponent } from './view/materials-page/materials-page.component';
import { AccordionModule } from 'primeng/accordion';
import { MultiSelectModule } from 'primeng/multiselect';
import { ListboxModule } from 'primeng/listbox';
import { InputTextModule } from 'primeng/inputtext';
import { AppRoutingModule } from '../../app-routing.module';
import { TableModule } from 'primeng/table';
import { MaterialsFilterButtonComponent } from './view/materials-page/materials-filter-button/materials-filter-button.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@NgModule({
    declarations: [
        VendorsPageComponent,
        VendorModalComponent,
        MaterialsPageComponent,
        MaterialsFilterButtonComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        MatDialogModule,
        MatRippleModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        SelectButtonModule,
        CalendarModule,
        CheckboxModule,
        MiscModule,
        DropdownModule,
        ConfirmDialogModule,
        DesktopProjectModule,
        ProjectMiscModule,
        AccordionModule,
        MultiSelectModule,
        ListboxModule,
        InputTextModule,
        AppRoutingModule,
        OverlayPanelModule
    ],
    entryComponents: [
        VendorModalComponent
    ]
})
export class VendorsModule { }
